module.exports = __webpack_public_path__ + "static/media/poisson.882b769a.png";